import t_06_2204 from './KZ.T.06.2204.svg'
import t_06_2204_b from './KZ.T.06.2204 black.svg'

export default [
  t_06_2204,
  t_06_2204_b,
]
